import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IZonezonePage } from '@/utils/types'

export default function useSeo(zonezone: IZonezonePage) {
  const globalStore = useGlobalStore()

  const title = `${zonezone?.seo?.meta_title || 'zonezone 概念店'}｜打造多元的種種生活嚮往${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = zonezone?.seo?.meta_description || globalStore.seoDescriptions.zonezone
  const url = `${import.meta.env.VITE_DOMAIN}/zonezone`

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: zonezone?.seo.og_image?.link,
    keywords: zonezone?.seo?.meta_keywords?.join(',')
  })
  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })
  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: zonezone?.seo?.meta_title || 'zonezone 概念店',
            item: url
          }
        ]
      }
    ]
  })
}
